import {Program, FrameBuffer, Texture, vec3} from '../../beam/index';
import settings from '../settings'

let time = 0;

import hdrSkyVS from '../shaders/hdr-sky-vs.glsl';
import hdrSkyFS0 from '../shaders/hdr-sky-1-fs.glsl';
import hdrSkyFS1 from '../shaders/hdr-sky-2-fs.glsl';
import hdrSkyFS2 from '../shaders/hdr-sky-3-fs.glsl';
import hdrSkyFS3 from '../shaders/hdr-sky-4-fs.glsl';

const SKY_SHADERS = [
    hdrSkyFS0,
    hdrSkyFS1,
    hdrSkyFS2,
    hdrSkyFS3
]

export default class HDRSky {
    constructor(renderer, options) {
        this.options = options || {}
        this.options.width = this.options.width || settings.skyResolution[0]//256
        this.options.height = this.options.height || settings.skyResolution[1]//128
        this.renderer = renderer
        
        for (let i= 0; i<4; i++) {
            this['material'+i] = new Program(this.renderer.gl, {
                vertexShader:  hdrSkyVS,
                fragmentShader: SKY_SHADERS[i],
            });
            this['material'+i].name = 'HDRSKY Mode ' + i
        }

        this.material = this['material'+settings.skyMode]; 

        this.frameBuffer = new FrameBuffer(this.renderer.gl, {
			width:   this.options.width,
            height:  this.options.height,
            linear: true,
            // type:   this.renderer.gl.FLOAT
        });
        this.noiseTexture = Texture.fromUrl(this.renderer.gl, `assets/textures/noise/256x256.png`, {
            linear: true,
            wrapS: this.renderer.gl.REPEAT,
            wrapT: this.renderer.gl.REPEAT,
        });
    }
    render(bufferScene, bufferPlane, bufferCamera) {

        this.material = this['material'+settings.skyMode];

        bufferPlane.material =	this.material
        
        // if (this.material.uniforms.uSunPosition) {
        //     this.material.uniforms.uSunPosition.value = [ settings.uSunPositionX, settings.uSunPositionY ];
        // }
        // if (this.material.uniforms.uSunDirection) {
        //     let sun = vec3.create()
        //     vec3.set(sun, 0.0, 0.0, 1.0)
        //     vec3.rotateX( sun, sun, [0,0,0], -settings.uSunPositionY*Math.PI/2.0 );
        //     vec3.rotateY( sun, sun, [0,0,0], -settings.uSunPositionX*Math.PI + Math.PI/2    );
        //     this.material.uniforms.uSunDirection.value = sun;
        // }
        
        this.material.setUniform('uSkyEyeHeight', settings.uSkyEyeHeight);
        this.material.setUniform('tNoise', this.noiseTexture);
        this.material.setUniform('iResolution', [this.options.width, this.options.height]);
        this.material.setUniform('iTime', time);

        time += 0.03;
        this.renderer.clearColor(0,0,0,1)
        this.renderer.clear()

        bufferPlane.name = 'HDRSkyPass'
        bufferPlane.id = 'HDRSkyPass'
        this.renderer.render( bufferScene, bufferCamera, this.frameBuffer );
    }
}